import { render, staticRenderFns } from "./cost-management-import.vue?vue&type=template&id=1b70c995&scoped=true"
import script from "./cost-management-import.vue?vue&type=script&lang=js"
export * from "./cost-management-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70c995",
  null
  
)

export default component.exports